import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { AntdRadioGroupButton as RadioButton } from '@yuhuinc/ui-library/';

const ServiceAndUtilityAnswerRadioButton = ({
  setFieldValue,
  question,
  isChild,
  selectedParentAnswer,
  selectedConditionalAnswer,
  parentIndex,
  selectedParentAnswerIndex,
  index,
  serviceOrUtility,
  isMobile,
}) => {
  const radioGroupData = (parentQuestion) => {
    let dataSet = [];

    if (!isEmpty(parentQuestion.answers)) {
      dataSet = parentQuestion.answers.map((ans) => ({
        label: ans.answer_name,
        value: ans.answer_value,
      }));
    }
    return dataSet;
  };

  const radioGroupDataForConditional = (conditionalQuestion) => {
    let dataSet = [];

    if (!isEmpty(conditionalQuestion.conditional_answers)) {
      dataSet = conditionalQuestion.conditional_answers.map((ans) => ({
        label: ans.name,
        value: ans.value,
      }));
    }
    return dataSet;
  };

  const handleChildValueChange = (e) => {
    let newValueAnswers = [
      ...selectedParentAnswer.conditional_questions[index].conditional_answers,
    ];

    newValueAnswers.forEach((ans) => {
      if (ans.value === e.target.value) {
        ans.selected = true;
      } else {
        ans.selected = false;
      }
    });

    setFieldValue(
      `${serviceOrUtility}[${parentIndex}].answers[${selectedParentAnswerIndex}].conditional_questions[${index}].conditional_answers`,
      newValueAnswers
    );
  };

  const handleParentValueChange = (e) => {
    let newValueAnswers = [...question.answers];
    newValueAnswers.forEach((ans) => {
      if (ans.answer_value === e.target.value) {
        ans.selected = true;
      } else {
        ans.selected = false;
      }
    });
    setFieldValue(`${serviceOrUtility}[${parentIndex}].answers`, newValueAnswers);
  };

  if (isChild) {
    return (
      <RadioButton
        radioGroupData={radioGroupDataForConditional(question)}
        disabled={false}
        isMobile={isMobile}
        value={selectedConditionalAnswer.value}
        handleChange={(e) => handleChildValueChange(e)}
        key={index}
      />
    );
  }

  return (
    <RadioButton
      radioGroupData={radioGroupData(question)}
      disabled={false}
      isMobile={isMobile}
      value={selectedParentAnswer?.answer_value}
      handleChange={(e) => handleParentValueChange(e)}
      key={index}
    />
  );
};

export { ServiceAndUtilityAnswerRadioButton };
